import { render, staticRenderFns } from "./FailureModal.vue?vue&type=template&id=241ae826&scoped=true&"
import script from "./FailureModal.vue?vue&type=script&lang=js&"
export * from "./FailureModal.vue?vue&type=script&lang=js&"
import style0 from "./FailureModal.vue?vue&type=style&index=0&id=241ae826&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ae826",
  null
  
)

export default component.exports